<template>
  <div class="exercise-wrapper page" id="wrapperdiv">
    <!-- Client strip -->
    <div class="report-head" v-if="userData && userData.program">
      <div class="report-head-cell">
        <span class="rh-label">{{ $t("Name") }}</span>
        <span class="rh-value">{{ userData.name }}</span>
      </div>
      <div class="report-head-cell">
        <span class="rh-label">{{ $t("Age") }}</span>
        <span class="rh-value">{{ userData.age }}</span>
      </div>
      <div class="report-head-cell">
        <span class="rh-label">{{ $t("Start") }}</span>
        <span class="rh-value">{{
          new Date(userData.program.startDate).toLocaleDateString($i18n.locale)
        }}</span>
      </div>
      <div class="report-head-cell">
        <span class="rh-label">{{ $t("Progress") }}</span>
        <span class="rh-value">
          {{ Math.ceil(userData.program.exercisesDone / 12) }} /
          {{ userData.program.exercisesTotal / 12 }}
          <span class="rh-unit">{{ $t("Sets") }}</span>
        </span>
      </div>
    </div>

    <!-- How to read the charts -->
    <div class="report-legend">
      <span class="lg-item">
        <span class="lg-key lg-key-score"></span>
        {{ $t("Performance") }}
        <em>({{ $t("Score") }} · {{ $t("Group") }})</em>
      </span>
      <span class="lg-item">
        <span class="lg-key lg-key-trend"></span>
        {{ $t("Trend") }}
      </span>
      <span class="lg-item">
        <span class="lg-key lg-key-band"></span>
        {{ $t("Target Range") }} (0–100)
      </span>
      <span class="lg-item">
        <span class="lg-key lg-key-axis">1…n</span>
        {{ $t("Sets") }}
      </span>
      <span class="lg-item lg-note">{{ $t("A = advanced level, E = entry level") }}</span>
    </div>

    <!-- Attention Chart Row-->
    <b-row class="chart-row chart-row-first">
      <b-col cols="12">
        <vue-apex-charts
          height="200"
          width="100%"
          :options="chartOptions('attention', $t('Attention') + ' ' + $t('Performance'))"
          :series="[attentionChartData, attentionTrendData]"
          :key="refreshKey"
        />
      </b-col>
    </b-row>
    <!-- Logic Chart Row-->
    <b-row class="chart-row">
      <b-col cols="12">
        <vue-apex-charts
          height="200"
          width="100%"
          :options="chartOptions('logic', $t('Logic') + ' ' + $t('Performance'))"
          :series="[logicChartData, logicTrendData]"
          :key="refreshKey"
        />
      </b-col>
    </b-row>
    <!-- Concentration Chart Row-->
    <b-row class="chart-row">
      <b-col cols="12">
        <vue-apex-charts
          height="200"
          width="100%"
          :options="
            chartOptions('concentration', $t('Concentration') + ' ' + $t('Performance'))
          "
          :series="[concentrationChartData, concentrationTrendData]"
          :key="refreshKey"
        />
      </b-col>
    </b-row>
    <!-- Memory Chart Row-->
    <b-row class="chart-row">
      <b-col cols="12">
        <vue-apex-charts
          height="200"
          width="100%"
          :options="chartOptions('memory', $t('Memory') + ' ' + $t('Performance'))"
          :series="[memoryChartData, memoryTrendData]"
          :key="refreshKey"
        />
      </b-col>
    </b-row>
    <!-- Time & Mistake Charts -->
    <!-- <b-row style="margin-top: 20px">
      <b-col cols="3" class="d-flex justify-content-start">
        <span class="data-text ml-3">{{ $t("Name") }}:</span>
        <span class="data-text ml-1">{{ userData.name }}</span>
      </b-col>
      <b-col cols="3" class="d-flex justify-content-start">
        <span class="data-text">{{ $t("Age") }}:</span>
        <span class="data-text ml-1">{{ userData.age }}</span>
      </b-col>
      <b-col cols="3" class="d-flex justify-content-end">
        <span class="data-text">{{ $t("Start") }}:</span>
        <span class="data-text ml-1">{{ new Date(userData.program.startDate).toLocaleDateString($i18n.locale)
          }}</span>
      </b-col>
      <b-col cols="3" class="d-flex justify-content-end">
        <span class="data-text">{{ $t("Progress") }}:</span>
        <span class="data-text ml-1 mr-1">({{ Math.ceil(userData.program.exercisesDone / 12) }} /
          {{ userData.program.exercisesTotal / 12 }})</span>
      </b-col>
    </b-row>
    <b-row style="margin-top: -45px">
      <b-col md="12" sm="12">
        <vue-apex-charts height="220" width="100%" :options="{
            ...smallChartOptions,
            title: {
              text: $t('Attention') + ' ' + $t('Time-Mistake Averages'),
              offsetY: 25,
              align: 'center',
              style: {
                color: '#000',
              },
            },
          }" :series="smallChartData[0].series" :key="refreshKey" />
      </b-col>
     </b-row>
    <b-row style="margin-top: -45px">
      <b-col md="12" sm="12">
        <vue-apex-charts height="220" width="100%" :options="{
            ...smallChartOptions,
            title: {
              text: $t('Logic') + ' ' + $t('Time-Mistake Averages'),
              offsetY: 25,
              align: 'center',
              style: {
                color: '#000',
              },
            },
          }" :series="smallChartData[1].series" :key="refreshKey" />
      </b-col>
    </b-row>
    <b-row style="margin-top: -45px">
      <b-col md="12" sm="12">
        <vue-apex-charts height="220" width="100%" :options="{
            ...smallChartOptions,
            title: {
              text: $t('Concentration') + ' ' + $t('Time-Mistake Averages'),
              offsetY: 25,
              align: 'center',
              style: {
                color: '#000',
              },
            },
          }" :series="smallChartData[2].series" :key="refreshKey" />
      </b-col>
    </b-row>
    <b-row style="margin-top: -45px">
      <b-col md="12" sm="12">
        <vue-apex-charts height="220" width="100%" :options="{
            ...smallChartOptions,
            title: {
              text: $t('Memory') + ' ' + $t('Time-Mistake Averages'),
              offsetY: 25,
              align: 'center',
              style: {
                color: '#000',
              },
            },
          }" :series="smallChartData[3].series" :key="refreshKey" />
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BCard,
  BSpinner,
  BButton,
  BModal,
} from "bootstrap-vue";
// import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import UserViewUserInfoCard from "./UserViewUserInfoCard.vue";
import ChartsjsLineChart from "./ChartjsLineChart.vue";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import StatisticCardWithAreaChart from "@core/components/statistics-cards/StatisticCardWithAreaChart.vue";
import VueApexCharts from "vue-apexcharts";
import userStoreModule from "./parentStoreModule";
// import UserViewUserPlanCard from "./UserViewUserPlanCard.vue";
import TestCard from "./TestCard.vue";
import UserViewUserTimelineCard from "./UserViewUserTimelineCard.vue";
import UserViewUserPermissionsCard from "./UserViewUserPermissionsCard.vue";
import { smallChartOptions } from "./smallChartOptions";
import { buildReportChartOptions, packSessionValues } from "./lineChartOptions";
import { linearTrend } from "@/views/apps/user/utils/trend";
import axios from "@axios";
import StatisticCardWithLineChart from "@/@core/components/statistics-cards/StatisticCardWithLineChart.vue";
// import userData from "@/store/user-data";
// import {t as translate} from "@/libs/i18n";

// One accent per category. The report is printed in black & white, so each hue
// is picked dark enough that it renders as a distinctly dark gray; the tint is
// the near-white fill of that category's data-label pills.
const CATEGORY_THEME = {
  attention: { accent: "#6d28d9", tint: "#f5f3ff" },
  logic: { accent: "#1d4ed8", tint: "#eff6ff" },
  concentration: { accent: "#0f766e", tint: "#f0fdfa" },
  memory: { accent: "#c2410c", tint: "#fff7ed" },
};

const {
  axiosRoutes: { exercise: path },
} = require("/G_CONFIG");

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BCard,
    BSpinner,
    BButton,
    BModal,
    // Local Components
    UserViewUserInfoCard,
    TestCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,
    ChartsjsLineChart,
    StatisticCardVertical,
    StatisticCardWithAreaChart,
    StatisticCardWithLineChart,
    VueApexCharts,
    StatisticCardWithLineChart,
  },
  data() {
    return {
      refreshKey: 0,
      categoryOptions: {
        attention: buildReportChartOptions(CATEGORY_THEME.attention),
        logic: buildReportChartOptions(CATEGORY_THEME.logic),
        concentration: buildReportChartOptions(CATEGORY_THEME.concentration),
        memory: buildReportChartOptions(CATEGORY_THEME.memory),
      },
      bigChartData: [
        {
          name: "",
          data: [],
          series: [],
        },
        { name: "", data: [], series: [] },
        { name: "", data: [], series: [] },
        {
          name: "",
          data: [],
          series: [],
        },
      ],
      // areaChartModifiedOptions: {
      //   ...areaChartOptions,
      //   ...areaChartOptionsModify,
      // },
      smallChartOptions: smallChartOptions,
      panelTitles: ["", "", "", ""],
      panelIcons: ["AlertCircleIcon", "PieChartIcon", "CrosshairIcon", "DiscIcon"],
      chartColors: ["primary", "success", "info", "warning"],
      smallChartData: [
        {
          series: [
            { name: this.$t("Attention"), data: [0] },
            { name: this.$t("Attention"), data: [0] },
          ],
        },
        {
          series: [
            { name: this.$t("Concentration"), data: [0] },
            { name: this.$t("Concentration"), data: [0] },
          ],
        },
        {
          series: [
            { name: this.$t("Logic"), data: [0] },
            { name: this.$t("Logic"), data: [0] },
          ],
        },
        {
          series: [
            { name: this.$t("Memory"), data: [0] },
            { name: this.$t("Memory"), data: [0] },
          ],
        },
      ],
      attentionChartData: {
        name: "",
        data: [],
        series: [],
      },

      concentrationChartData: {
        name: "",
        data: [],
        series: [],
      },
      logicChartData: {
        name: "",
        data: [],
        series: [],
      },
      memoryChartData: {
        name: "",
        data: [],
        series: [],
      },
      // Per-category linear trend lines (gray) overlaid on each report chart.
      attentionTrendData: { name: this.$t("Trend"), data: [] },
      logicTrendData: { name: this.$t("Trend"), data: [] },
      concentrationTrendData: { name: this.$t("Trend"), data: [] },
      memoryTrendData: { name: this.$t("Trend"), data: [] },
      // groupChartOptions: {
      //   ...areaChartOptions,
      //   ...areaChartOptionsModify,
      //   ...groupChartOptionsModify,
      // },
    };
  },
  mounted() {
    // console.log(locale);
    // document.querySelector("#app > div").classList.add("exercise-wrapper");
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("dark-layout");
    body.style.background = "#fff";
    let app = document.getElementById("app");
    app.classList.remove("h-100");
    window.addEventListener("afterprint", function () {
      window.close();
    });
  },
  methods: {
    // The title sits inside the chart's own top padding, which the negative row
    // margin below then tucks under the previous chart.
    chartOptions(category, title) {
      return {
        ...this.categoryOptions[category],
        title: {
          text: title,
          offsetY: 25,
          align: "center",
          style: { color: "#111827", fontSize: "13px", fontWeight: 700 },
        },
      };
    },
    testReportClicked(data) {
      this.$refs.testReport.show();
    },
    numberToGrade(number) {
      const values = ["A", "B", "C", "D", "E"];
      return values[number - 1];
    },
    dataFetched(data) {
      const names = (this.panelTitles = Object.keys(data.smallChartData));
      for (let i = 0; i < names.length; i++) {
        this.smallChartData[i].series[0].data = data.smallChartData[
          names[i]
        ][0].data.map((x) => (x > 6 ? 0 : x));
        this.smallChartData[i].series[0].name = data.smallChartData[names[i]][0].label;
        this.smallChartData[i].series[1].data = data.smallChartData[
          names[i]
        ][1].data.map((x) => (x > 6 ? -1 : x));
        // this.smallChartData[i].series[1].data = data.smallChartData[names[i]][0].data.map(
        //   (x, index) => this.smallChartData[i].series[0].data[index] - x
        // );
        this.smallChartData[i].series[1].name = data.smallChartData[names[i]][1].label;
        this.panelTitles[i] = this.$t(names[i]);
      }
      console.log(this.smallChartData);
      this.renderTable(data);
      this.refreshKey++;
    },
    renderTable(data) {
      if (this.userData == undefined || this.userData.program == undefined) {
        setTimeout(() => {
          this.renderTable(data);
        }, 300);
        return;
      } else {
      }
      const { attention, logic, concentration, memory } = this.userData.program.groups;

      // Each plotted point carries its score and the group it was scored in.
      this.attentionChartData.data = packSessionValues(
        data.bigChartData[0].data,
        attention.change,
        attention.group
      );
      this.logicChartData.data = packSessionValues(
        data.bigChartData[1].data,
        logic.change,
        logic.group
      );
      this.concentrationChartData.data = packSessionValues(
        data.bigChartData[2].data,
        concentration.change,
        concentration.group
      );
      this.memoryChartData.data = packSessionValues(
        data.bigChartData[3].data,
        memory.change,
        memory.group
      );
      // Linear best-fit trend per category, computed on the displayed values.
      this.attentionTrendData.data = linearTrend(this.attentionChartData.data);
      this.logicTrendData.data = linearTrend(this.logicChartData.data);
      this.concentrationTrendData.data = linearTrend(this.concentrationChartData.data);
      this.memoryTrendData.data = linearTrend(this.memoryChartData.data);
      this.refreshKey++;
      // const divs = document.querySelectorAll("#app > div");
      // console.log(divs);
      setTimeout(() => {
        window.print();
      }, 1000);
    },
  },
  async created() {
    document.getElementById("loading-bg").style.display = "block";
    const id = window.location.pathname.substring(
      window.location.pathname.lastIndexOf("/") + 1
    );
    try {
      const { data: response } = await axios.get(`${path.stats + id}`);
      this.bigChartData = response.bigChartData;
      console.log(response);
      // this.logicChartData.data = this.logicChartData.map((val, index) => {
      //   return val + "|" + logicGroupChange[index];
      // });
      // this.concentrationChartData.data = this.concentrationChartData.map((val, index) => {
      //   return val + "|" + concentrationGroupChange[index];
      // });
      // this.memoryChartData.data = this.memoryChartData.map((val, index) => {
      //   return val + "|" + memoryGroupChange[index];
      // });
      this.dataFetched(response);
    } catch (error) {
      console.log(error);
    } finally {
      document.getElementById("loading-bg").style.display = "none";
    }
  },
  setup(data) {
    const userData = ref(null);
    const testData = ref(null);
    const userFetched = ref(false);
    const USER_APP_STORE_MODULE_NAME = "app-user";
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch("app-user/fetchUser", { id: router.currentRoute.params.id })
      .then((response) => {
        userData.value = response.data.subject;
        testData.value = response.data.testData;
        userFetched.value = true;
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });
    return {
      userData,
      testData,
      userFetched,
    };
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "Swiss 721", sans-serif;
}

/* Client strip: micro-label above value, hairline rules between cells. Reads as
   a form header on screen and prints cleanly with no filled areas. */
.report-head {
  display: flex;
  align-items: stretch;
  border: 1px solid #d5d9e0;
  border-radius: 4px;
  overflow: hidden;
}
.report-head-cell {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 4px 12px;
  border-left: 1px solid #e8eaee;
}
.report-head-cell:first-child {
  border-left: 0;
}
.rh-label {
  font-size: 7.5px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #64748b;
}
.rh-value {
  font-size: 12px;
  font-weight: 700;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rh-unit {
  font-size: 8px;
  font-weight: 600;
  color: #64748b;
  text-transform: lowercase;
}

/* Legend: what each mark on the charts means. */
.report-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 18px;
  padding: 5px 12px 0;
  font-size: 8.5px;
  font-weight: 600;
  color: #374151;
}
.lg-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
.lg-item em {
  font-style: normal;
  color: #64748b;
}
.lg-key {
  display: inline-block;
  width: 22px;
  height: 8px;
  flex: none;
}
.lg-key-score {
  height: 0;
  border-top: 2.5px solid #1f2937;
}
.lg-key-trend {
  height: 0;
  border-top: 4px dotted #9aa3af;
}
.lg-key-band {
  height: 7px;
  border-top: 1.5px solid #1f2937;
  border-bottom: 1.5px solid #1f2937;
}
.lg-key-axis {
  width: auto;
  font-size: 8px;
  font-weight: 700;
  color: #64748b;
}
.lg-note {
  margin-left: auto;
  color: #64748b;
}

/* Each chart reserves empty space above its centred title. The negative margin
   tucks that space under the previous chart's x-axis, which is what lets four
   charts fit the 200mm print box. The first chart tucks less so that its title
   clears the header strip instead of landing on top of it. */
.chart-row {
  margin-top: -50px;
}
.chart-row-first {
  margin-top: -18px;
}
@page {
  size: A4;
  margin: 0;
  size: landscape;
}

@media print {
  @page {
    size: A4;
    margin: 5mm;
    size: landscape;
    pages: 1;
  }
}
.exercise-wrapper {
  height: 200mm;
  width: 297mm;
}
#app > div {
  height: 200mm;
  width: 297mm;
}
#app {
  height: 200mm;
  width: 297mm;
}
.page-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
}
/* .page {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
} */
</style>

<style>
/* Dots (not dashes) for the trend line — series index 1 on every chart.
   ApexCharts can only emit a dash and a gap of equal length, so a dotted line
   has to come from CSS; it writes `stroke-dasharray` as an SVG attribute, which
   any stylesheet rule outranks. Deliberately unscoped: the SVG is created by the
   chart component, so a scoped rule would never reach it. */
#wrapperdiv .apexcharts-series[data\:realIndex="1"] path {
  stroke-dasharray: 0.01 9;
  stroke-linecap: round;
}
</style>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
